<div style="margin: 10px 10px 10px 10px;">
  <form [formGroup]="form">
    <div class="mb-3 row" style="margin-top: 30px;">
      <fieldset>
        <legend>Copy Network Credentials</legend>
      </fieldset>
    </div>

    <div class="mb-3 row">
      <div class="col-lg-1">
        <span>Source Network:</span>
      </div>
      <div class="col-lg-3">
        <select class="form-control" [formControl]="sourceNetwork">
          @for (sourceName of allNetViewNames; track sourceName) {
            <option value="{{sourceName}}">{{sourceName}}</option>
          }
        </select>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-1">
        <span>Target Network:</span>
      </div>
      <div class="col-3">
        <select class="form-control" [formControl]="targetNetwork">
          @for (targetName of allNetViewNames; track targetName) {
            <option value="{{targetName}}">{{targetName}}</option>
          }
        </select>
      </div>
    </div>

    <div class="mb-3 row">
      <span class="col-lg-2">&nbsp;</span>
      <div class="col-lg-3" style="height: 60px; display: flex; justify-content: center; align-items: center;">
        <button [disabled]="!enableCopy" type="button" pButton label="Copy" (click)="tryCopyProtocols()"></button>
      </div>
      <div class="col-lg-2" style="height: 60px; display: flex; justify-content: left; align-items: center;">
        <input type="checkbox" title="Copy source credentials to all other networks" style="display:none" [formControl]="doAll"/>
        <span class="uv-checkbox-label" style="display:none">To All Networks</span>
      </div>
    </div>

  </form>

  <confirmation-dialog message="Are you sure you want to copy the source credentials to the target network?"
    [display]="displayCopyProtocolsConfirm"
    (onYes)="copyProtocols()" (onNo)="cancelCopyProtocols()">
  </confirmation-dialog>
</div>
